import type { ReviewEntryItem } from '../types/reviewEntryItem'
import type { ReviewEntryLine } from '../types/reviewEntryLine'
import { getReviewEntryContactId } from './getReviewEntryContactId'

const getLineFingerprint = (line: ReviewEntryLine) => ({
  accountId: line.accountId ?? null,
  amountExclVat: line.amountExclVat ?? line.amountExclTax ?? null,
  amountInclVat: line.amountInclVat ?? line.amountInclTax ?? null,
  description: line.description ?? null,
  taxRateId: line.taxRateId ?? null,
  vatAmount: line.vatAmount ?? line.taxAmount ?? null,
})

export const getReviewEntrySourceFingerprint = (item: ReviewEntryItem): string =>
  JSON.stringify({
    currencyId: item.currencyId ?? null,
    entryDate: item.entryDate ?? null,
    entryLines: (item.entryLines ?? []).map(getLineFingerprint),
    reference: item.reference ?? null,
    selectedContactId: getReviewEntryContactId(item.processingDecision),
    supplierName: item.supplierName ?? null,
  })
